function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import { Radio, Form, Button, Divider, Checkbox, Image, message, Input, Select, Alert, Space, Col as AntCol, Row as AntRow } from 'antd';
import { Container, Col, Row } from "react-bootstrap";
import Common from "../includes/Common";
import PrescriptionList from "../pieces/PrescriptionList";
import Moment from "react-moment";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;

var NewPharmacyPrescription = function NewPharmacyPrescription(_ref) {
  var _ref$patient = _ref.patient,
      patient = _ref$patient === void 0 ? null : _ref$patient,
      _ref$check = _ref.check,
      check = _ref$check === void 0 ? null : _ref$check,
      handler = _ref.handler;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      drugsOptions = _useState2[0],
      setDrugsOptions = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      deptOptions = _useState4[0],
      setDeptOptions = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      deptData = _useState6[0],
      setDeptData = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isFormProcessing = _useState8[0],
      setIsFormProcessing = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      errorMessage = _useState10[0],
      setErrorMessage = _useState10[1];

  var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      successMessage = _useState12[0],
      setSuccessMessage = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      itemsData = _useState14[0],
      setItemsData = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      itemsOptionsData = _useState16[0],
      setItemsOptionsData = _useState16[1];

  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      drugList = _useState18[0],
      setDrugList = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      bilans = _useState20[0],
      setBilans = _useState20[1];

  var _useState21 = useState([]),
      _useState22 = _slicedToArray(_useState21, 2),
      quantities = _useState22[0],
      setQuantities = _useState22[1];

  var _useState23 = useState(0),
      _useState24 = _slicedToArray(_useState23, 2),
      position = _useState24[0],
      setPosition = _useState24[1];

  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  var onFinish = function onFinish() {
    setIsFormProcessing(true);
    setErrorMessage("");
    setSuccessMessage("");
    var formData = new FormData();
    formData.append("bilan", bilans);
    formData.append("quantities", quantities.join(","));
    if (check == null) formData.append("medical_check_id", null);else formData.append("medical_check_id", check.id);
    formData.append("user_id", Common.currentUser.id);
    formData.append("dcode", "PHA");
    axios.post(Common.baseApiUrl + "setbilan", formData).then(function (response) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      if (response.data.status == 200) {
        handler();
        setSuccessMessage("Prescriptions effectuées avec succès");
        var content = document.getElementById("prtdiv");
        var pri = document.getElementById("ifmcontentstoprint").contentWindow;
        pri.document.open();
        pri.document.write(content.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  var onAddPrescription = function onAddPrescription(values) {
    var item = drugsOptions.filter(function (o) {
      return o.value == values.bilan;
    })[0];

    if (drugList.filter(function (i) {
      return i.id == values.bilan;
    }).length > 0) {
      var extElementQuant = drugList.filter(function (i) {
        return i.id == item.value;
      })[0].quantity;
      setDrugList(drugList.filter(function (i) {
        return i.id != item.value;
      }));
      setDrugList(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.value,
          label: item.label,
          quantity: extElementQuant + 1,
          comment: values.comment,
          position: position
        }]);
      });
    } else {
      setDrugList(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.value,
          label: item.label,
          quantity: 1,
          comment: values.comment,
          position: position + 1
        }]);
      });
      setPosition(function (prev) {
        return prev + 1;
      });
    }

    setBilans(function (prev) {
      return [].concat(_toConsumableArray(prev), [values.bilan]);
    });
    setQuantities([]);
    drugList.forEach(function (i) {
      setQuantities(function (prev) {
        return [].concat(_toConsumableArray(prev), [i.quantity]);
      });
    });
  };

  var handleDeptChange = function handleDeptChange(e) {
    setItemsOptionsData([]);
    var ar = deptData.filter(function (d) {
      return d.id.toString() == e.target.value;
    });

    if (ar.length > 0) {
      ar.forEach(function (d) {
        d.services.forEach(function (s) {
          setItemsOptionsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [s]);
          });
        });
      });
    }
  };

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getservicetree').then(function (response) {
      if (response.data.status == 200) {
        var ars = response.data.services.filter(function (d) {
          return d.type == 2 && d.dcode == 'PHA';
        });
        ars.forEach(function (d) {
          setItemsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [d]);
          });
          d.medical_items.forEach(function (m_i) {
            setDrugsOptions(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                label: m_i.label,
                value: m_i.id
              }]);
            });
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: [/*#__PURE__*/_jsxs(AntRow, {
        gutter: 16,
        children: [/*#__PURE__*/_jsx(AntCol, {
          span: 4,
          children: /*#__PURE__*/_jsx(Image, {
            preview: false,
            src: "/drawables/logo_sos.jpeg",
            width: "130px",
            style: {
              width: "130px"
            }
          })
        }), /*#__PURE__*/_jsx(AntCol, {
          span: 10,
          children: /*#__PURE__*/_jsx("h4", {
            style: {
              textAlign: "center",
              marginTop: '40px'
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "ORDONNANCE MEDICALE"
            })
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "Date:"
        }), " ", /*#__PURE__*/_jsx(Moment, {
          format: "DD/MM/YYYY H:m"
        })]
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["CODE PATIENT : ", patient.idnumber]
      }), /*#__PURE__*/_jsxs("h5", {
        children: ["Nom : ", patient.firstname + " " + patient.lastname]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(PrescriptionList, {
        data: drugList
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h6", {
        children: /*#__PURE__*/_jsx("b", {
          children: "SIGNATURE ET CACHET DU MEDECIN"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: "Dr ".concat(Common.currentUser.firstname, " ").concat(Common.currentUser.lastname)
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: Conakry, Kaloum, Manquepas - Tel: 622 32 59 32"
        })
      })]
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsxs(Form, {
            layout: "vertical",
            form: form,
            onFinish: onAddPrescription,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "department",
              children: /*#__PURE__*/_jsx(Radio.Group, {
                onChange: handleDeptChange,
                options: deptOptions,
                optionType: "button",
                buttonStyle: "solid"
              })
            }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              type: "error",
              message: errorMessage,
              banner: true
            }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              type: "success",
              message: successMessage,
              banner: true
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "bilan",
              rules: [{
                required: true,
                message: "Veuillez choisir une option"
              }],
              children: /*#__PURE__*/_jsx(Select, {
                size: "large",
                filterOption: true,
                optionFilterProp: "label",
                allowClear: true,
                showSearch: true,
                placeholder: "Choisir les produits",
                style: {
                  width: '100%'
                },
                options: drugsOptions
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "comment",
              label: "Posologie",
              children: /*#__PURE__*/_jsx(TextArea, {
                placeholder: "Posologie ici"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormProcessing,
                disabled: drugsOptions.length == 0,
                htmlType: "submit",
                type: "primary",
                children: /*#__PURE__*/_jsx("b", {
                  children: "AJOUTER"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Divider, {})]
        }), /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(PrescriptionList, {
              data: drugList
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Button, {
                loading: isFormProcessing,
                onClick: onFinish,
                disabled: drugList.length == 0,
                type: "primary",
                children: /*#__PURE__*/_jsx("b", {
                  children: "PRESCRIRE"
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "link",
                disabled: drugList.length == 0,
                onClick: function onClick() {
                  setDrugList([]);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "EFFACER"
                })
              })]
            })]
          })
        })]
      })
    })]
  });
};

export default NewPharmacyPrescription;